const images = [
    "01_20180128_Marco_Meazza_Peri_08_MG_2701.jpg",
    "02_20180128_Marco_Meazza_Peri_05_MG_2015.jpg",
    "03_20180128_Marco_Meazza_Peri_07_MG_2423.jpg",
    "04_20180128_Marco_Meazza_Peri_MG_1814.jpg",
    "05_20180128_Marco_Meazza_Peri_07_MG_2573.jpg",
    "07_20180518_Marco_Meazza_CurlyCarity_MG_4759.jpg",
    "08_20180318_Marco_Meazza_CynthiaScreen-Shot-2018-06-19-at-17.00.32.jpg",
    "08_20180520_Marco_Meazza_InesLongevial7280_test.jpg",
    "09_20180520_Marco_Meazza_InesLongevial7044.jpg",
    "10_20180118_Marco_Meazza_Wet2139.jpg",
    "11_20180128_Marco_Meazza_Peri_MG_1615.jpg",
    "12_20171206_Marco_Meazza_TFP_MG_8399-copy.jpg",
    "13_20171206_Marco_Meazza_TFP0144-copy.jpg",
    "14_20171206_Marco_Meazza_TFP__MG_8337-copy.jpg",
    "15_20171206_Marco_Meazza_TFP0218-copy.jpg",
    "16_20170921_Marco_Meazza_INDIEmag_02_0767.jpg",
    "17_20170921_Marco_Meazza_INDIEmag_04_1659.jpg",
    "18_20170921_Marco_Meazza_INDIEmag_05_1823.jpg",
    "19_20170921_Marco_Meazza_INDIEmag_20170921_Marco_Meazza_Playhaus2394.jpg",
    "20_0170921_Marco_Meazza_Playhaus_08_2423.jpg",
    "21_20171015_Marco_Meazza_CoolUK_02_0109_LowRes.jpg",
    "22_20171015_Marco_Meazza_CoolUK_09_1873_LowRes.jpg",
    "23_20171128_Marco_Meazza_TFP0819_LowRes.jpg",
    "24_20171128_Marco_Meazza_TFP0830_LowRes.jpg",
    "25_20171128_Marco_Meazza_TFP0923_LowRes.jpg",
    "26_20171128_Marco_Meazza_TFP1272_LowRes.jpg",
    "27_20170619_Marco_Meazza_Theo&Louie_03_MG_9321_HighRes_sRGB.jpg",
    "28_20170619_Marco_Meazza_Theo&Louie_02_MG_9263_HighRes_sRGB.jpg",
    "29_20170619_Marco_Meazza_Theo&Louie_02_MG_9292_HighRes_sRGB.jpg",
    "30_20170618_Marco_Meazza_Theo&Louie_02_0386_HighRes_sRGB.jpg",
]

export default images


// WEBPACK FOOTER //
// ./src/constants/images.js